import '@paxsudos/frontend/patch-status-counters.js';
import { connect } from 'react-redux';
import { List as ImmutableList, Map as ImmutableMap } from 'immutable';
import StatusList from '@/mastodon/components/status_list';

const mapStateToProps = (state, { timelineId }) => {
  const base = ['timelines', timelineId];

  // eri versioissa items/statusIds/entries
  const ids =
    state.getIn([...base, 'items']) ||
    state.getIn([...base, 'statusIds']) ||
    state.getIn([...base, 'entries']) ||
    ImmutableList();

  const isLoading = !!state.getIn([...base, 'isLoading']);
  const hasMore = !!(state.getIn([...base, 'next']) || state.getIn([...base, 'hasMore']));

  return {
    statusIds: ids,     // StatusList odottaa tätä
    isLoading,
    hasMore,
  };
};

export default connect(mapStateToProps)(StatusList);
